module.exports = "/packs/media/images/StepSavings_2-a2c25bd410c701136d9e626756113581.png";